import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { StockReplenishmentExtendedListResponse, StockReplenishmentQueryParams } from '@frontend/stock/types';

export class StockReplenishmentExtendedClient extends APIClient {
    public static readonly endpoint = '/stock-api/ext/v1';

    public static async fetchStockReplenishmentsExtended(
        queryParams?: ApiQueryParams<StockReplenishmentQueryParams>
    ): Promise<StockReplenishmentExtendedListResponse> {
        return await this.apiPaginated<StockReplenishmentExtendedListResponse, StockReplenishmentQueryParams>(`${this.endpoint}/replenishment`, queryParams);
    }
}
